<div class="xcard" [class.answered]="answered">
  <h4 class="x-title">{{ name }}</h4>
  <p class="x-sub">{{ description }}</p>

  <div class="unit-fields">
    <div class="field">
      <label [id]="'item-type-' + matchId">Item type</label>
      <div class="fixed-type" *ngIf="isService; else typePicker" [attr.aria-labelledby]="'item-type-' + matchId">Service</div>
      <ng-template #typePicker>
        <div class="segmented-control" role="group" [attr.aria-labelledby]="'item-type-' + matchId">
          <button
            type="button"
            class="segmented-option"
            *ngFor="let type of itemTypes"
            [class.active]="itemTypeId === type.id"
            [attr.aria-pressed]="itemTypeId === type.id"
            [disabled]="saving"
            (click)="itemTypeId !== type.id && itemTypeChange.emit(type.id)"
          >
            {{ type.label }}
          </button>
        </div>
      </ng-template>
    </div>

    <div class="field">
      <label [for]="'unit-' + matchId">Unit in Aivor</label>
      <select #unitSelect [id]="'unit-' + matchId" [disabled]="saving" (change)="onSelect($any($event.target).value)">
        <option value="" disabled>Choose a unit…</option>
        <option *ngFor="let unit of units" [value]="unit.id">{{ unit.name }} ({{ unit.code }})</option>
      </select>
    </div>
  </div>
</div>
